export default __webpack_public_path__ + "static/media/0058.43bb3217.png";